import React from 'react';

import './styles.css';

interface ToggleSwitchProps {
  onChange?: () => void;
  value: boolean;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  onChange = () => {},
  value
}) => (
  <label className="ToggleSwitch colab-clickable">
    <input type="checkbox" onChange={onChange} checked={value} />
    <div className="ToggleSwitch__container">
      <div className="ToggleSwitch__switch" />
    </div>
  </label>
);

export default ToggleSwitch;
